/**
 * services/hire/aiUsage.ts
 * Client for the detailed AI-usage endpoint (GET /api/hire/v2/ai/usage). Uses
 * the shared axios instance (platform session cookie); org-scoped server-side.
 */
import axiosInstance from '../../api/axiosInstance';
import { HireMatch_Ai_Usage_Url } from '../../api/endpoints';
import type { AiUsageDetail, AiUsageOpFilter } from '../../schemas/hire/aiUsage';

export interface AiUsageParams {
  page?: number;
  pageSize?: number;
  op?: AiUsageOpFilter;
  days?: number;
}

const EMPTY: AiUsageDetail = {
  summary: { totalTokens: 0, inputTokens: 0, outputTokens: 0, totalCalls: 0, rerankRuns: 0, models: 0, users: 0 },
  byOp: [], byModel: [], byUser: [], bySource: [], series: [],
  entries: { items: [], page: 1, pageSize: 20, total: 0 },
};

export async function getAiUsageDetail(params: AiUsageParams = {}, signal?: AbortSignal): Promise<AiUsageDetail> {
  const { data } = await axiosInstance.get<AiUsageDetail>(HireMatch_Ai_Usage_Url, {
    params: {
      ...(params.page ? { page: params.page } : {}),
      ...(params.pageSize ? { pageSize: params.pageSize } : {}),
      ...(params.op && params.op !== 'all' ? { op: params.op } : {}),
      ...(params.days ? { days: params.days } : {}),
    },
    signal,
  });
  return data && data.summary ? data : EMPTY;
}
